(() => {
  'use strict';
  if (window.shrineVariantCartSync) return;
  window.shrineVariantCartSync = true;
  const states = new WeakMap();
  const selector = 'variant-selects, variant-radios';

  function resolve(picker) {
    const options = Array.from(picker.querySelectorAll('.product-form__input')).map(group =>
      group.querySelector('select, input[type="radio"]:checked')?.value);
    let variants;
    try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); }
    catch { return { options, variant: null }; }
    return { options, variant: variants.find(variant => variant.options.length === options.length &&
      variant.options.every((value, index) => value === options[index])) || null };
  }

  function formsFor(picker) {
    const section = picker.dataset.section;
    return Array.from(document.forms).filter(form => form.getAttribute('id') === `product-form-${section}` ||
      form.getAttribute('id') === `product-form-installment-${section}` ||
      (form.closest('product-form')?.dataset.section === section));
  }

  function sync(picker) {
    const result = resolve(picker);
    picker.currentVariant = result.variant;
    const allowed = Boolean(result.variant?.available);
    formsFor(picker).forEach(form => {
      Array.from(form.elements).filter(input => input.name === 'id').forEach(input => {
        const value = result.variant ? String(result.variant.id) : '';
        const changed = input.value !== value;
        input.value = value;
        input.disabled = !allowed;
        if (changed) input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      form.querySelectorAll('[type="submit"]').forEach(button => {
        button.dataset.unavailable = String(!allowed);
        button.disabled = !allowed;
        button.setAttribute('aria-disabled', String(!allowed));
      });
    });
    picker.querySelectorAll('[data-variant-label-template]').forEach((label, index) => {
      const group = label.closest('.product-form__input');
      const groupIndex = Array.from(picker.querySelectorAll('.product-form__input')).indexOf(group);
      const name = label.dataset.optionName || '';
      const values = { '[count]': String(groupIndex + 1), '[name]': name,
        '[name_lowercase]': name.toLowerCase(), '[name_uppercase]': name.toUpperCase(),
        '[selected]': result.options[groupIndex] || '' };
      label.textContent = label.dataset.variantLabelTemplate.replace(/\[count\]|\[name\]|\[name_lowercase\]|\[name_uppercase\]|\[selected\]/g, token => values[token]);
    });
    return result;
  }

  async function refresh(picker, variant, state) {
    state.controller?.abort();
    state.controller = new AbortController();
    const controller = state.controller;
    if (!variant || !picker.dataset.url) return;
    const section = picker.dataset.section;
    const originalSection = picker.dataset.originalSection || section;
    const url = new URL(picker.dataset.url, location.origin);
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('section_id', originalSection);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Variant section unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted || !picker.isConnected || resolve(picker).variant?.id !== variant.id) return;
      for (const prefix of ['price-', 'Sku-', 'Inventory-']) {
        const source = html.getElementById(`${prefix}${originalSection}`);
        const target = document.getElementById(`${prefix}${section}`);
        if (source && target) target.innerHTML = source.innerHTML;
      }
      const sourceButton = html.getElementById(`ProductSubmitButton-${originalSection}`);
      const targetButton = document.getElementById(`ProductSubmitButton-${section}`);
      const sourceLabel = sourceButton?.querySelector('.main-atc__label');
      const targetLabel = targetButton?.querySelector('.main-atc__label');
      if (sourceLabel && targetLabel) targetLabel.innerHTML = sourceLabel.innerHTML;
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('[Shrine] Could not refresh variant display; selected cart ID remains synchronized.');
    }
  }

  function onSelection(event) {
    if (!event.target.matches('select, input[type="radio"]')) return;
    const picker = event.target.closest(selector);
    if (!picker || customElements.get(picker.localName)) return;
    const { variant, options } = sync(picker);
    let state = states.get(picker);
    if (!state) { state = {}; states.set(picker, state); }
    const key = JSON.stringify(options);
    if (state.key === key) return;
    state.key = key;
    if (variant && picker.dataset.updateUrl !== 'false' && !picker.dataset.originalSection) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
    document.querySelectorAll('media-gallery').forEach(gallery => {
      if (gallery.dataset.section !== picker.dataset.section || gallery.onVariantChange || !variant?.featured_media) return;
      gallery.setActiveMedia?.(`${picker.dataset.section}-${variant.featured_media.id}`, true,
        Boolean(gallery.dataset.filteringOption), variant);
    });
    refresh(picker, variant, state);
  }

  document.addEventListener('input', onSelection, true);
  document.addEventListener('change', onSelection, true);
  document.addEventListener('submit', event => {
    const picker = Array.from(document.querySelectorAll(selector)).find(item => formsFor(item).includes(event.target));
    if (!picker || customElements.get(picker.localName)) return;
    const { variant } = sync(picker);
    if (!variant?.available) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.target.closest('product-form')?.showError?.(variant ? window.variantStrings?.soldOut : window.variantStrings?.unavailable);
    }
  }, true);
})();

